import { Lock } from 'lucide-react';

/**
 * MfaHero — left-panel content for AUTH-02 MFA Verification.
 *
 * "Two-Factor Authentication" subtitle, 2-line body, and a Copper Sun lock
 * icon in a surface-raised circle — matching Figma frame 68:52 hero column.
 */
export function MfaHero() {
  return (
    <div className="flex flex-col gap-6">
      <p className="text-xl font-semibold text-[var(--text-primary)]">Two-Factor Authentication</p>
      <p className="text-[15px] leading-snug text-[var(--text-secondary)]">
        Add an extra layer of security
        <br />
        to protect your account.
      </p>
      <div className="mt-4 flex size-[120px] items-center justify-center rounded-full bg-[var(--bg-surface-raised)]">
        <Lock className="size-12 text-[var(--text-accent)]" strokeWidth={1.5} />
      </div>
    </div>
  );
}
